<template>
  <div id="agreement">
    <div v-if="content" v-html="content" class="content" />
    <div v-else class="content">
      <p>
        感谢您使用 AnyTeach
        约课平台的产品和服务。使用、购买我们的服务即表示您已同意本服务条款，请仔细阅读。您仅能在法律允许的范围内以及
        AnyTeach
        的服务条款的政策之内使用我们的服务。如果您不遵守我们的条款或政策，或者我们在调查可疑的不当行为，我们可以暂停或停止向您提供服务。
      </p>
      <ol>
        <li>
          <h2>服务简介</h2>
          <div>
            <p>
              AnyTeach
              的服务涵盖“直播课”、“王冰暗示法英语”、“同城拼课”、和“游学”。作为一个教育服务提供者，我们的宗旨是提升
              AnyTeach 学员的英语能力。
            </p>
            <p>
              <strong>同城拼课</strong>
              <br />同城拼课由 1 名发起人在 AnyTeach 约课平台上发起课程并邀请 2 至 7
              人参与加入该课程并通过微信支付缴纳学费。
              <br />
              <br />关于拼课时间和地点：
              <br />i. 一旦确定拼课时间，在拼课期间内不允许随意更改，但每
              3 个月发起人拥有 1 次单次调整上课时间的机会。
              <br />ii.
              拼课地点在拼课期间内不允许随意更改。
              <br />iii.
              除学员家长之外，拼课不允许未支付学费的人员旁听。
              <br />
            </p>
          </div>
        </li>
        <li>
          <h2>教学服务与权责声明</h2>
          <p>
            作为一个教学服务提供者，AnyTeach 的服务方向是增强学员的英语能力。然而，AnyTeach
            不为任何学员的应试成绩进行担保。因此，学员的学校成绩或在其他机构进行英语水平测试的结果无法构成退款或投诉的理由。若您有提升英语应试能力的需求，我们可以指定
            1 名 AnyTeach 课程顾问与您预约时间，一起制定适合您的学习计划。
          </p>
          <p>
            <strong>更换教师</strong>
            <br />AnyTeach 的中外教学团队经过严格筛选和培训，每位教师都富有教学经验及资质。AnyTeach
            视更换授课教师为正常情况，非特殊情况，因此并不对短期内（任何期限）更换教师的最低次数做出承诺。如果您无法接受短期内更换授课教师、或可能因更换授课教师而投诉退款，请勿购买或使用我们的服务。
          </p>
        </li>
        <li>
          <h2>退款</h2>
          <p>
            如有任何原因需要申请退款，应根据不同 AnyTeach 提供的不同课程，遵循不同退款规则：
            <br />i. 直播课（趣蒙课、成长营，不包含王冰暗示法英语）退款期限为 7 天。购买课程 7
            天内可无理由退款，7 天后不接受退款。
            <br />ii. 同城拼课缴费后入读未满 1
            个月，学费按照所剩余学费的 80% 予以退款。
            <br />iii. 同城拼课缴费后入读超过 1 个月至 3
            个月，学费按照所剩余学费的 50% 予以退款。缴费后入读超 3 个月以上，学费不予退款。
            <br />iv. 缴费所赠教材需按市场价格从退款中扣除相应费用。
            <br />v.
            若获赠学习券已使用于任何课程，则需从学费中扣除其抵用消费的服务的市场价格，以实际剩余学费予以退款。
            <br />vi.
            学习券纯属赠品，非用户所购买的商品。若获赠的学习券在申请退款时仍未使用，学习券的价值无法折算为退款金额，更无法转赠他人。
            <br />vii.
            赠送课时纯属赠品，非用户所购买的商品。所有的赠送课时应在实际课时完成后使用。赠送课时数无法折算为退款金额。
          </p>
        </li>
        <li>
          <h2>双十一活动</h2>
          <p>
            所有双十一活动特价课程均标有“双十一”字样，属于促销价格，一经支付不接受退款或换课，请根据自身情况合理消费。
          </p>
        </li>
      </ol>
      <p>最后修订日期：2020 年 11 月 8 日。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Agreement",
  data() {
    return {
      content: null
    }
  },
  created() {
    this.getContent()
    this.wechatInit()
  },
  methods: {
    async getContent() {
      const { value_1 } = await this.$api.api.CUSTOM("user_agreement_web")
      if (value_1.length) {
        this.content = value_1
      }
    },
    wechatInit() {
      //微信分享配置

      wx.ready(() => {
        bus.wxShareConfig({
          type: "all",
          url: "/#/agreement",
          name: window.document.title,
          desc: "感谢您使用 AnyTeach 的产品和服务，请仔细阅读我们的服务条款。",
        })
      })
    },
  },
}
</script>
<style type="text/css" lang="scss">
// @import "../../../static/css/public.scss";
#agreement {
  background: white;
  overflow: scroll !important;
  .content {
    padding: 20px 5% 0 5%;
  }
  h1 {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    padding-left: 10px;
    border-left: 3px solid $red;
  }
  h2 {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.3;
    margin-bottom: 10px;
  }
  p {
    font-size: 0.9rem;
    margin-bottom: 20px;
    line-height: 1.7;
    @include avenir();
  }
  ol {
    counter-reset: li;
    margin: 0;
    padding: 0;
  }
  ol > li {
    position: relative;
    padding-left: 20px;
  }
  ol > li:before {
    content: counter(li);
    counter-increment: li;

    position: absolute;
    left: 0px;

    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.3;
    color: $black;
    font-size: 25px;
    font-weight: 300;
    @include avenir();
    opacity: 0.4;
  }
}
</style>
